import React, { useCallback } from 'react';
import { Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getCallLogId } from '../../common/common';
import { useCartData, useServiceablitityData } from '../../hooks/order';
import { CheckScheduleAppt, setRtsAttemptCount, setRtsVisible } from '../../store/action/OrderAction';
import { useNavigate } from 'react-router-dom';
import { routesConfig } from '../../util/util';
const RtsModal = ({ handleCheckout, onDismiss }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const callLogId = getCallLogId();
  const { internetPlan } = useCartData();
  const { isRtsVisible, scheduleLoading, rtsAttemptCount } = useServiceablitityData();

  const handleRetryScheduling = useCallback(async () => {
    dispatch(setRtsAttemptCount(rtsAttemptCount + 1));
    await dispatch(CheckScheduleAppt({
      userName: 'xmlc',
      serviceReference: internetPlan?.servRef,
      callLogId
    }))
      .then(res => {
        if (res.value.data.installWindow && res.value.data.installWindow.length > 0) {
          dispatch(setRtsVisible(false));
          handleCheckout();
          navigate(routesConfig.checkout);
        } else {
          if (rtsAttemptCount === 2) {
            dispatch(setRtsAttemptCount(0));
            dispatch(setRtsVisible(false));
            if (onDismiss) {
              onDismiss();
            } else {
              navigate(routesConfig.home);
            }
          }
        }
      });
  }, [CheckScheduleAppt, dispatch, internetPlan, callLogId, scheduleLoading, rtsAttemptCount, onDismiss, handleCheckout, navigate]);

  const handleModalClose = useCallback(() => {
    dispatch(setRtsAttemptCount(0));
    dispatch(setRtsVisible(false));
    if (onDismiss) {
      onDismiss();
    } else {
      navigate(routesConfig.products);
    }
  }, [setRtsVisible, dispatch, onDismiss, navigate]);

  return (
    <Modal
      visible={isRtsVisible}
      maskClosable={false}
      width={520}
      footer={null}
      closable={false}
      className="rts-modal"
    >
      <p>{t('rts.message')}</p>
      <div className="button-container">
        <Button
          htmlType="reset"
          className="cancel-btn"
          onClick={handleRetryScheduling}
          loading={scheduleLoading}
        >
          {t('rts.retryScheduling')}
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          className="submit-btn"
          onClick={handleModalClose}
        >
          {t('common.ok')}
        </Button>
      </div>
    </Modal>
  );
};
export default RtsModal;
